<template>
    <div id="support-ticket">
        <div class="box">
            <h1 id="title" class="title has-text-grey-dark"><i class="fa fa-life-ring"></i> Support Ticket</h1>
            <p class="subtitle">Dear Teacher ~ Please fill out the ticket below</p>
        </div>
        <!--<hr>-->
        <div class="columns" style="margin-top: 0;">
            <div class="box column is-6 is-offset-3">
                <div class="column">
                    <form>
                        <div class="field" v-if="$me.id == -1 || $me.id == null ">
                            <span class="label has-text-grey-dark">Email</span>
                            <bulma-input type="text" name="email" v-model="ticket.email" rules="required|email" placeholder='Email'/>
                        </div>
                        <div class="field">   
                            <span class="label has-text-grey-dark">Ticket category</span>
                            <div class="control">
                                <div class="select is-info is-fullwidth">
                                    <select v-model="ticket.category">
                                        <option value="bug">Bug</option>				                                      
                                        <option value="improvement">Improvement</option>				  
                                        <option value="other">Other</option>				  
                                    </select>
                                </div>
                            </div>                      
                        </div>  
                        <div class="field">
                            <span class="label has-text-grey-dark">Title</span>
                            <bulma-input type="text" name="title" v-model="ticket.title" rules="required" placeholder='Ticket title'/>
                        </div>
                        <div class="field">
                            <span class="label has-text-grey-dark">Please specify your issue/suggestion</span>
                            <div class="control">                                                
                                <textarea id="sentence" class="is-primary textarea" name="content" v-model="ticket.content"  v-validate="'required'"  v-bind:class="{'input': true, 'is-danger': errors.has('sentence') }" 
                                    type="text" 
                                    placeholder="Content..."></textarea>
                                <transition name="fade-fast">
                                    <span v-show="errors.has('content')" class="help is-danger">{{ errors.first('content') }}</span>
                                </transition>
                          </div>
                        </div> 
                        <div class="field">
                            <div class="control">
                                <loading-button v-bind:loading="loading" color="is-info" @click="send">Send</loading-button>                                   
                            </div>
                        </div> 
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TicketRepo from '../repos/TicketRepo'
import _ from 'lodash'

export default {
  name: 'support-ticket',

    data() {
        return {
            ticket: {category:"bug"},
            loading: false,
            repo: new TicketRepo(this.$auth),
        }
    },
  methods: {
    send() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.loading = true;
                    this.repo.store(this.ticket).then(response => {                        
                        this.loading = false;
                        this.$toast.info(response.data.message);
                    }).catch((response) =>{                    
                        this.loading = false;
                        return Promise.reject(response);
                    });                 
                }
            });
    }
     
  }
  
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/SupportTicket.vue